export const ERROR_MESSAGE =
  "Something went wrong, please try again. If the problem persists, please contact support.";

export const FILE_UPLOAD_ERROR_MESSAGE =
  "The file could not be processed. Possible reasons: unsupported file format, file size exceeds the limit, or a corrupted file. Please try again with a valid file.";
